// extracted by mini-css-extract-plugin
export default {"viewport":"viewport-Z4DPSW8cRjuXagnQGqOn"};